import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const branchPositionLocaleModule: LocaleModule = {
  name: "branchPosition",
  messages: { en: en, it: it },
};
